export default {
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: 450,
    height: 420,
    margin: 20,
    alignItems: 'center'
  },
  chart: {
    width: 400
  },
  text: {
    textAlign: 'center',
    margin: 5
  }
};
